export default function PlusIcon() {
  return (
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.7598 7.07H0.695801V5.918H5.7598V0.854004H6.9358V5.918H11.9998V7.07H6.9358V12.146H5.7598V7.07Z"
        fill="#3B342A"
      />
    </svg>
  );
}
